<script>
import { formatBarsHorizontal_v2 } from '@utils/GraficoData'

export default {
  name: 'AlocacaoEstrategicaChartBody',
  props: {
    hasData: {
      type: Boolean,
      default: false,
    },
    chartData: {
      type: Object,
      default: () => ({}),
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    chartContainerClass() {
      return [
        'alocacao-estrategica__content-chart',
        this.noPadding && 'alocacao-estrategica__content-chart--no-padding',
      ]
    },
    formattedChart() {
      const SHOW_LABEL_END_OF_BAR = true
      return formatBarsHorizontal_v2(this.chartData, SHOW_LABEL_END_OF_BAR)
    },
  },
}
</script>

<template>
  <div v-if="hasData" :class="chartContainerClass">
    <div v-if="height" :key="height" :style="{ height: height + 'px' }">
      <bar-horizontal-chart
        :chart-data="formattedChart.chartData"
        :options="formattedChart.chartOptions"
        :plugins="formattedChart.chartPlugins"
        :height="height"
      />
    </div>
    <bar-horizontal-chart
      v-else
      :chart-data="formattedChart.chartData"
      :options="formattedChart.chartOptions"
      :plugins="formattedChart.chartPlugins"
    />
  </div>
  <div v-else class="alocacao-estrategica__content-empty">
    <div class="text-center text-color-600">
      Nenhum dado disponível para exibição
    </div>
  </div>
</template>
